export default __webpack_public_path__ + "static/media/minion.eb074e97.svg";